<template>
  <v-card v-if="ticket">
    <v-card-title>
      <v-avatar size=48>
        <v-icon color="primary" large>local_play</v-icon>
      </v-avatar>
      <span class="subheading text-uppercase pl-2">
        {{ticket.attributes.title}}
      </span>
    </v-card-title>

    <v-card-text>
      <v-form ref="form">
        <v-text-field
          prepend-icon=" "
          label="Title"
          name="title"
          v-model="localTicket.title"
          :maxlength="maxCharacters"
          :counter="maxCharacters"
          :rules="[rules.required]"
          >
        </v-text-field>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="cancel()">Cancel</v-btn>
      <v-btn color="primary" @click="updateTicket()" :disabled="!localTicket.title || busy" :loading="busy">Update Ticket</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { EventBus } from '@/utilities/event-bus'

  import ticketService from '@/services/ticket'

  export default {
    name: 'ticket-edit',

    props: ['ticket'],

    data () {
      return {
        localTicket: {},
        maxCharacters: 100,
        busy: false,
        rules: {
          required: value => !!value || 'Required'
        }
      }
    },

    mounted () {
      this.localTicket = Object.assign({}, this.ticket.attributes)
    },

    computed: {
    },

    methods: {

      cancel () {
        // NOTE: roll back any changes we made (project is passed in by reference)
        this.localTicket = Object.assign({}, this.ticket.attributes)
        EventBus.$emit('ticket-updated')
      },

      updateTicket () {
        this.busy = true
        ticketService.update(
          (data) => {
            this.localTicket = data.attributes
            EventBus.$emit('ticket-updated', data)
            this.busy = false
          },
          (err) => {
            this.busy = false
            console.log(err)
          },
          this.localTicket
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/ticket/_edit.vue